import { jsx as _jsx } from "react/jsx-runtime";
export function Skeleton({ width = "100%", height = "1rem", label = "Carregando", className, style, ...rest }) {
    return (_jsx("span", { className: ["evolua-skeleton", className].filter(Boolean).join(" "), style: { width, height, ...style }, role: "status", "aria-label": label, ...rest }));
}
//# sourceMappingURL=Skeleton.js.map